import { forwardRef } from 'react';

import ReactQuill from 'react-quill-new';

import { reactQuillDefaultModules } from '@/lib';

import 'react-quill/dist/quill.snow.css';
import './ReactQuillTextEditor.css';

const TextEditor = forwardRef<ReactQuill, ReactQuill.ReactQuillProps>(
  (props, ref) => (
    <ReactQuill
      ref={ref}
      theme="snow"
      modules={reactQuillDefaultModules}
      bounds="div.quill"
      {...props}
    />
  ),
);

TextEditor.displayName = 'TextEditor';

export { TextEditor };
